import { Box, Typography, Grid } from '@mui/material';
import React from 'react';
import {
  Carousel,
  IconicRideCard,
} from 'views/rebranded-module/common/components';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import StyledBox from 'views/rebranded-module/tours-module/ToursLandingViewV2/components/IconicRidersSection/IconicRidersSection.styles';
import PATHS from 'lib/navigation/paths';
import { REFS } from 'views/rebranded-module/common/utils/constants';

const IconicRidersSection = (props) => {
  const { iconicRides } = props;
  const content = useContent('ToursLandingPage');
  const tourLandingRef = REFS.MOTORCYCLE_TOUR_LANGING;

  return (
    <StyledBox>
      <Box className="IRSSectionContainer">
        <Typography variant="h3" component="h2" pb={2}>
          {content.iconicHeader}
        </Typography>
        <Typography className="IRSubTitle" variant="body2" component="p" pb={3}>
          {content.iconicSubheader}
        </Typography>
        <Box position="relative" className="showTabletAndDesktop">
          <Carousel
            swipeable
            infinite
            showDots={false}
            keyBoardControl
            minimumTouchDrag={20}
            renderDotsOutside
            desktopPartialVisibilityGutter={20}
            largeDesktopPartialVisibilityGutter={20}
            deskTopItems={3}
            carouselArrow
            customTransition="transform 200ms ease-in">
            {iconicRides.map((item) => (
              <IconicRideCard
                key={item.id}
                title={item.name}
                image={{
                  src: item.cover_image_url,
                  alt: item.name,
                }}
                link={PATHS.experience(item.slug, {
                  ref: tourLandingRef,
                })}
                dataTestId={`tour-iconic-ride-${encodeURIComponent(item.slug)}`}
                description={item.subtitle}
              />
            ))}
          </Carousel>
        </Box>
        <Box className="showMOBILE">
          <Grid container spacing={2}>
            {iconicRides.map((item) => (
              <Grid item sm={12} key={item.id}>
                <IconicRideCard
                  title={item.name}
                  image={{
                    src: item.cover_image_url,
                    alt: item.name,
                  }}
                  link={PATHS.experience(item.slug, {
                    ref: tourLandingRef,
                  })}
                  dataTestId={`tour-iconic-ride-${encodeURIComponent(
                    item.slug,
                  )}`}
                  description={item.subtitle}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    </StyledBox>
  );
};

export { IconicRidersSection };
